import React from "react";
import { TrendUp, TrendDown } from "@phosphor-icons/react";

export function StatCard({ label, value, delta, icon: Icon, accent, suffix }) {
  const up = delta >= 0;
  return (
    <div className="card-matte p-5 fade-up" data-testid={`stat-${label.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
      <div className="flex items-start justify-between">
        <div className="label-caps">{label}</div>
        {Icon && (
          <div className={`h-8 w-8 rounded-lg flex items-center justify-center ${accent ? "bg-[#6B3DFF]/15" : "bg-white/5"}`}>
            <Icon size={16} className={accent ? "brand-text" : "text-[#9a9a9a]"} weight="bold" />
          </div>
        )}
      </div>
      <div className="mt-3 font-head text-2xl md:text-[28px] font-semibold tracking-tight">
        {value}{suffix}
      </div>
      {delta !== undefined && delta !== null && (
        <div className={`mt-1.5 flex items-center gap-1 text-xs font-medium ${up ? "text-emerald-400" : "text-red-400"}`}>
          {up ? <TrendUp size={14} weight="bold" /> : <TrendDown size={14} weight="bold" />}
          {Math.abs(delta)}% <span className="text-[#7a7a7a] font-normal">vs last week</span>
        </div>
      )}
    </div>
  );
}
